import { Link } from '@design-system/link';
import React, { FC } from 'react';

import { UtilityLinksProps } from '../../models';

export const UtilityLinks: FC<UtilityLinksProps> = ({
  linkNavElement: LinkElement = Link,
  utilityLinksData = [],
  utilityLinksName,
}) => (
  <nav aria-label={utilityLinksName} className="cds-utility-navigation">
    <ul className="cds-utility-navigation__list">
      {utilityLinksData.map(({ href, label, ariaLabel, ...rest }) => (
        <li key={label} className="cds-utility-navigation__item">
          <LinkElement
            className="cds-utility-navigation__link"
            href={href}
            variant="subtle"
            size="small"
            aria-label={ariaLabel}
            {...rest}
          >
            {label}
          </LinkElement>
        </li>
      ))}
    </ul>
  </nav>
);
